import { FOOTER } from "@/constants/testIds";
import { Linkedin, Mail } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-ink">
      <div className="mx-auto max-w-[1440px] px-6 md:px-16 pt-24 pb-12">
        <div className="grid grid-cols-12 gap-6 items-end">
          <div className="col-span-12 md:col-span-8">
            <div className="font-serif-display text-ivory text-6xl md:text-8xl lg:text-9xl leading-[0.9] tracking-[-0.03em]">
              asadhatimi<span className="text-brass italic">.</span>com
            </div>
          </div>
          <div className="col-span-12 md:col-span-4">
            <div className="space-y-3 text-ivory/85 text-sm md:text-right">
              <a
                href="mailto:asadhatimi@gmail.com"
                data-testid={FOOTER.email}
                className="inline-flex items-center gap-3 link-underline hover:text-brass"
              >
                <Mail size={14} className="text-brass" /> asadhatimi@gmail.com
              </a>
              <br />
              <a
                href="https://www.linkedin.com/in/asad-hatimi-program-leader"
                target="_blank"
                rel="noopener noreferrer"
                data-testid={FOOTER.linkedin}
                className="inline-flex items-center gap-3 link-underline hover:text-brass"
              >
                <Linkedin size={14} className="text-brass" /> LinkedIn — Program Leader
              </a>
            </div>
          </div>
        </div>

        <div className="hairline my-12" />

        <nav
          aria-label="Footer navigation"
          className="mb-10 flex flex-wrap gap-x-7 gap-y-4 text-[11px] uppercase tracking-[0.2em] text-mutedfg"
        >
          <a className="hover:text-brass" href="/industrial-project-management-consultant-india/">
            Project Management
          </a>
          <a className="hover:text-brass" href="/project-recovery-schedule-acceleration/">
            Project Recovery
          </a>
          <a className="hover:text-brass" href="/capital-project-governance-advisory/">
            CAPEX Governance
          </a>
          <a className="hover:text-brass" href="/cement-steel-project-consulting/">
            Cement &amp; Steel
          </a>
          <a className="hover:text-brass" href="/independent-director-industrial-sector/">
            Board Practice
          </a>
          <a className="hover:text-brass" href="/insights/">
            Insights
          </a>
        </nav>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] uppercase tracking-[0.22em] text-mutedfg">
          <span>© {year} Asad Hatimi — Industrial Project Leadership</span>
          <span>Project Advisory · CAPEX Governance · Board Practice</span>
          <span>Udaipur, Rajasthan · India</span>
        </div>
      </div>
    </footer>
  );
}
